import { createForm } from 'shared-ui/lib/customs/form/FormGenerator';
import { FormInput } from 'shared-ui/lib/customs/form/FormInput';
import { userInputs } from '../../inputs/user.inputs';

const form: FormInput[] = [
  userInputs.email,
  userInputs.businessName,
  userInputs.name,
  userInputs.password,
  userInputs.terms,
  userInputs.isAccepted,
];

export const businessRegisterForm = createForm(form);

export type BusinessRegisterFormBody = {
  email: string;
  name: string;
  businessName: string;
  password: string;
  isAccepted: boolean;
};
